import { request } from '../utils'
import { ReturnType } from './types'

const requestOtp = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'otp/send',
      method: 'post',
      data,
      config: {
        showErr: true,
        successMsg: 'Otp sent successfully!',
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const verifyOtp = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'otp/verify',
      method: 'post',
      data,
      config: {
        showErr: true,
        successMsg: 'OTP Verified Successfully!',
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const registerUser = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users',
      method: 'post',
      data,
      config: {
        showErr: true,
        successMsg: 'User Registered Successfully!',
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const login = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users/login',
      method: 'post',
      data,
      config: {
        showErr: true,
        successMsg: 'Login successful!',
        store: {
          action: 'set',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const find = async (action: any, state: string, id: any) => {
  try {
    const config: ReturnType = {
      url: `users/${id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: action,
          key: state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const logout = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users/logout',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Logout successful!',
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const resetPassword = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users/reset-password',
      method: 'patch',
      data,
      config: {
        showErr: true,
        successMsg: 'Password Rest Successfully!',
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const updateProfile = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users/update',
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Profile Updated Successfully!',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const updateStatus = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `users/status/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Account Deleted Successfully!',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const ChangePassword = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'users/change-password',
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Profile Updated Successfully!',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const list = async (state: string, params: any) => {
  try {
    const config: ReturnType = {
      url: 'users',
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  requestOtp,
  verifyOtp,
  registerUser,
  login,
  logout,
  resetPassword,
  ChangePassword,
  find,
  updateProfile,
  list,
  updateStatus,
}
